import React from "react";

const Disputes = () => {
  return <div>Disputes</div>;
};

export default Disputes;
